import type { SegmentedControlsProps, SegmentProps } from './SegmentedControls.types'
import cn from 'classnames'
import * as React from 'react'
import { Segment } from './Segment'
import styles from './SegmentedControls.module.css'

export function SegmentedControls({
  children,
  className,
  defaultActive,
  disabled,
  fixed,
  onActiveChange,
  ...attributes
}: SegmentedControlsProps) {
  const [active, setActive] = React.useState(defaultActive ?? 0)

  const onClickHandler = (index: number, value?: string | number | readonly string[]) => {
    setActive(index)
    onActiveChange?.({ index, value })
  }

  return (
    <div
      className={cn(
        styles.wrapper,
        { [styles.fixed]: fixed, [styles.disabled]: disabled },
        className,
      )}
      {...attributes}
    >
      {React.Children.map(children, (child, index) => {
        if (React.isValidElement<SegmentProps>(child)) {
          const { disabled: childDisabled, name, value } = child.props
          return React.cloneElement(child, {
            active: [name, value].includes(active) || index === active,
            onClick: () => onClickHandler(index, value),
            disabled: disabled || childDisabled,
          })
        }
      })}
    </div>
  )
}

SegmentedControls.Segment = Segment
